import { createContext } from "react";

export const LANGUAGES = {
  RUS: "RUS",
  ENG: "ENG",
  UKR: "UKR",
  BEL: "BEL",
  PL: "PL",
};

export const STRINGS = {
  [LANGUAGES.ENG]: {
    MYACCOUNT: "MY ACCOUNT",
    FILTER: "FILTERS",
    BYALGORITHM: "By Algorithm",
    BYCOIN: "By Coin",
    BYEQUIPMENT: "By Equipment",
    BYMANUFACTURER: "By Manufacturer",
    MINIMUMPRICE: "Minimum price",
    MAXMUMPRICE: "Maximum price",
    SEARCH: "Search",
    ONSALE: "ON SALE",
    VIEV: "Viev",
    NEWLISTNING: "NEW LISTNING",
    NEWS: "NEWS",
    DETAILS: "Details",
    HASHRATE: "Hash rate",
    ADDCART: "Add to cart",
    HOME: "HOME",
    SELL: "SELL",
    HOST: "HOST",
    ABOUTAS: "ABOUT AS",
    SUPPORT: "SUPPORT",
    AFTER: " items in your cart",
    BEFORE: "You have ",
    CONTINUE: "Continue",
    REMOVEALL: "Remove all",
  },
  [LANGUAGES.RUS]: {
    MYACCOUNT: "Мой аккаунт",
    FILTER: "ФИЛЬТРЫ",
    BYALGORITHM: "По алгоритму",
    BYCOIN: "Монетой",
    BYEQUIPMENT: "По оборудованию",
    BYMANUFACTURER: "Производитель",
    MINIMUMPRICE: "Минимальная цена",
    MAXMUMPRICE: "Максимальная цена",
    SEARCH: "Поиск",
    ONSALE: "В ПРОДАЖЕ",
    VIEV: "Вид",
    NEWLISTNING: "НОВЫЙ СПИСОК",
    NEWS: "НОВОСТИ",
    DETAILS: "подробности",
    HASHRATE: "Скорость хеширования",
    ADDCART: "Добавить в корзину",
    HOME: "ДОМОЙ",
    SELL: "ПРОДАМ",
    HOST: "CЕРВЕР",
    ABOUTAS: "О НАС",
    SUPPORT: "СЛУЖБА ПОДДЕРЖКИ",
    AFTER: " товара в корзине",
    BEFORE: "У вас ",
    CONTINUE: "Продолжить",
    REMOVEALL: "Удалить все",
  },
  [LANGUAGES.UKR]: {
    MYACCOUNT: "Мій аккаунт",
    FILTER: "ФIЛЬТРИ",
    BYALGORITHM: "За алгоритмом",
    BYCOIN: "Монетою",
    BYEQUIPMENT: "По устаткуванню",
    BYMANUFACTURER: "Виробник",
    MINIMUMPRICE: "Мінімальна ціна",
    MAXMUMPRICE: "Максимальна ціна",
    SEARCH: "Пошук",
    ONSALE: "У ПРОДАЖУ",
    VIEV: "Вид",
    NEWLISTNING: "НОВИЙ СПИСОК",
    NEWS: "НОВИНИ",
    DETAILS: "подробиці",
    HASHRATE: "швидкість хешування",
    ADDCART: "Додати в кошик",
    HOME: "ДОДОМУ",
    SELL: "ПРОДАМ",
    HOST: "CЕРВЕР",
    SUPPORT: "СЛУЖБА ПІДТРИМКИ",
    AFTER: " товара в кошику",
    BEFORE: "У вас ",
    CONTINUE: "продовжувати",
    REMOVEALL: "Видалити всі",
  },
  [LANGUAGES.BEL]: {
    MYACCOUNT: "Мой рахунак",
    FILTER: "ФIЛЬТРИ",
    BYALGORITHM: "Па алгарытме",
    BYCOIN: "Манета",
    BYEQUIPMENT: "На абсталяванне",
    BYMANUFACTURER: "Вытворца",
    MINIMUMPRICE: "Мінімальны кошт",
    MAXMUMPRICE: "Максімальны кошт",
    HOME: "ДОДОМУ",
    SEARCH: "Пошук",
    ONSALE: "ПРОДАЖ",
    VIEV: "Вид",
    NEWLISTNING: "НОВЫ СПІС",
    NEWS: "НАВІНЫ",
    DETAILS: "дэталі",
    HASHRATE: "хуткасць мяшання",
    ADDCART: "Дадаць у кошык",
    SELL: "ПРОДАЖ",
    HOST: "CЕРВЕР",
    ABOUTAS: "ПРА НАС",
    SUPPORT: "СЛУЖБА ПІДТРИМКИ",
    AFTER: " прадметы",
    BEFORE: "У вас у кошыку ",
    CONTINUE: "працягваць",
    REMOVEALL: "Выдаліць усе",
  },
  [LANGUAGES.PL]: {
    MYACCOUNT: "Moje konto",
    FILTER: "FILTERS",
    BYALGORITHM: "Algorytm",
    BYCOIN: "Moneta",
    BYEQUIPMENT: "Na wyposażeniu",
    BYMANUFACTURER: "Рroducent",
    MINIMUMPRICE: "Minimalny koszt",
    MAXMUMPRICE: "Maksymalny koszt",
    SEARCH: "Szukaj",
    ONSALE: "SPRZEDAŻ",
    VIEV: "Rodzaj",
    NEWLISTNING: "NOWA LISTA",
    NEWS: "AKTUALNOŚCI",
    DETAILS: "Detale",
    HASHRATE: "prędkość mieszania",
    ADDCART: "Dodaj do koszyka",
    HOME: "DOM",
    SELL: "SPRZEDAŻ",
    HOST: "SERWER",
    ABOUTAS: "O NAS",
    SUPPORT: "SERWIS WSPARCIA",
    AFTER: " przedmioty w swoim koszyku",
    BEFORE: "Masz ",
    CONTINUE: "kontynuować",
    REMOVEALL: "Usuń wszystko",
  },
};

const LanguageContext = createContext(STRINGS[LANGUAGES.ENG]);

export default LanguageContext;
